let loadingDelayId = -1

export default {
    data() {
        return {}
    },
    methods: {
        toggleLoading(status) {
            clearTimeout(loadingDelayId)

            if (status) {
                $('.ih-loading').fadeIn()
            } else {
                loadingDelayId = setTimeout(() => {
                    $('.ih-loading').delay(500).fadeOut()
                }, 1000)
            }
        },
        download(res, from, to) {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(res)
            a.download = `${from}-${to} 銷售紀錄`

            a.href = url
            a.click()
            // a.remove()
            // window.URL.revokeObjectURL(url)
        }
    }
}